import { Alerts } from 'constants/alerts';

import { useApiContext } from 'context/apiContext';
import { FormProvider } from 'react-hook-form';
import { FilterContextProvider } from 'shared/mui/Filter/context/filterContext';
import {
  FilterResetButton,
  FilterApplyButton,
  FilterClearButton,
  FilterButton,
} from 'shared/mui/Filter/FilterButtons';
import { FilterChipsToolbar } from 'shared/mui/Filter/FilterChipsToolbar/FilterChipsToolbar';
import {
  FilterDrawer,
  FilterDrawerContent,
  FilterDrawerActionsButtons,
} from 'shared/mui/Filter/FilterDrawer';
import { FilterToolbar } from 'shared/mui/Filter/FilterToolbar/FilterToolbar';
import { cleanEmpty } from 'utils/cleanEmpty';

import { DashboardFilterChips } from './DashboardFilterChips';
import { DashboardFilterForm } from './DashboardFilterForm';
import { DashboardFilterSkeleton } from './DashboardFilterSkeleton';
import { useDashboardFilters } from './hooks/useDashboardFilters';

export const DashboardFilter: React.FC = () => {
  const { user } = useApiContext();
  const isEmptyMerchantAccess = user?.alerts.includes(Alerts.EmptyMerchantAccess);

  const {
    form,
    onSubmit,
    onReset,
    appliedFilters,
    setAppliedFilter,
    openDrawer,
    toggleDrawer,
    isFilterReady,
    isFilterPresetApplied,
  } = useDashboardFilters(isEmptyMerchantAccess);

  const isAppliedFilterExist = Object.keys(cleanEmpty(appliedFilters)).length > 0;

  if (!isFilterReady) {
    return <DashboardFilterSkeleton />;
  }

  return (
    <>
      <FilterToolbar
        leftActionsSlot={[
          <FilterButton
            disabled={isEmptyMerchantAccess}
            key="filter"
            onClick={toggleDrawer(true)}
          />,
        ]}
      />
      <FilterDrawer onClose={toggleDrawer(false)} open={openDrawer}>
        <FormProvider {...form}>
          <form noValidate onSubmit={form.handleSubmit(onSubmit)}>
            <FilterDrawerContent>
              <DashboardFilterForm />
            </FilterDrawerContent>
            <FilterDrawerActionsButtons>
              <FilterResetButton onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterDrawerActionsButtons>
          </form>
        </FormProvider>
      </FilterDrawer>
      <FilterChipsToolbar appliedFilters={appliedFilters}>
        <FilterContextProvider
          appliedFilters={appliedFilters}
          onReset={onReset}
          setAppliedFilter={setAppliedFilter}
        >
          <FormProvider {...form}>
            <DashboardFilterChips />
            <FilterClearButton
              key="clear"
              onClick={onReset}
              visible={isAppliedFilterExist && !isFilterPresetApplied}
            />
          </FormProvider>
        </FilterContextProvider>
      </FilterChipsToolbar>
    </>
  );
};
